import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css'; // Assuming you have some basic styles for the modal
import { Context } from "../../context";
import { ReactComponent as Close } from '../../svg/close.svg';
function ModalLvlUp({ isOpen, setOpen, personnage, token }) {
  //const fetchPersonnage = useContext(Context);
  const buttonRef = useRef(null);
  const { fetchPersonnage, actions } = useContext(Context);
  const [IsPushedStatVar, setIsPushedStatVar] = useState("");
  const [IsPushedStatFix, setIsPushedStatFix] = useState("");
  const [IsPushedVitality, setIsPushedVitality] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const ip = process.env.REACT_APP_IP;
  const handleSubmit = async () => {
    if (IsPushedStatVar === "" || IsPushedVitality === "") {
      setErrorMessage("Tous les champs doivent être remplis");
    } else {

      try {
        setErrorMessage("")
        await axios.put(`${ip}/lvlup`, {
          IsPushedStatVar,
          IsPushedVitality,
          IsPushedStatFix,
          personnage
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        fetchPersonnage();
        actions.fetchEnergies();
        await timeout(500)
        setOpen(false);
      } catch (error) {
        setErrorMessage('Erreur:', error);
      }
    }
  };

  const handleClickStatVar = (e) => {

    if (e.target.id === IsPushedStatVar) {
      setIsPushedStatVar("")
    } else {
      setIsPushedStatVar(e.target.id);
    }


  };
  const handleClickStatFixe = (e) => {

    if (e.target.id === IsPushedStatFix) {
      setIsPushedStatFix("")
    } else {
      setIsPushedStatFix(e.target.id);
    }


  };
  const handleClickVitality = (e) => {

    if (e.target.id === IsPushedVitality) {
      setIsPushedVitality("")
    } else {
      setIsPushedVitality(e.target.id);
    }


  };
  const handleClick = () => {
    const button = buttonRef.current;
    setTimeout(() => {
      button.classList.remove('submit');
      button.classList.add('submit');
    }, 500);
    handleSubmit();
  };


  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setErrorMessage('')
          setOpen(false)
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  function timeout(delay) {
    return new Promise(res => setTimeout(res, delay));
  }


  if (!isOpen) return null;



  return (
    <div className="modal-overlay">
      <div className='modal_flex' ref={wrapperRef}>
        <div className="close" onClick={() => setOpen(false)}><Close></Close></div>
        <div className="box-title-lvlUp"><span className="title-lvlUp">Montée de niveau</span></div>

        <div className="flexLevel">
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatVar}
          >
            <span id="Force" className={`front ${IsPushedStatVar === "Force" ? 'pushedF' : ''}`} >
              Force
            </span>
          </button>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatVar}
          >
            <span id="Agilité" className={`front ${IsPushedStatVar === "Agilité" ? 'pushedA' : ''}`} >
              Agilité
            </span>
          </button>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatVar}
          >
            <span id="CapMagique" className={`front ${IsPushedStatVar === "CapMagique" ? 'pushedCM' : ''}`} >
              Capacité magique
            </span>
          </button>
        </div>
        {personnage.Niveau % 10 == 9 && <div className="flexLevel">
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatFixe}
          >
            <span id="Intelligence" className={`front ${IsPushedStatFix === "Intelligence" ? 'pushedI' : ''}`} >
              Intelligence
            </span>
          </button>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatFixe}
          >
            <span id="Social" className={`front ${IsPushedStatFix === "Social" ? 'pushedS' : ''}`} >
              Social
            </span>
          </button>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickStatFixe}
          >
            <span id="Observation" className={`front ${IsPushedStatFix === "Observation" ? 'pushedO' : ''}`} >
              Observation
            </span>
          </button>
        </div>}
        <div className='flexLevel'>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickVitality}>
            <span id="Energie" className={`front ${IsPushedVitality === "Energie" ? 'pushedE' : ''}`} >
              Energie
            </span>
          </button>
          <button
            className='pushable pushable_lvl'
            onClick={handleClickVitality}>
            <span id="Vie" className={`front ${IsPushedVitality === "Vie" ? 'pushedV' : ''}`} >
              Vie
            </span>
          </button>
        </div>
        <div className="button-lvlUp margin_1em" onClick={handleClick}>
          <button className="submit" ref={buttonRef}>Level UP !</button>
        </div>
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

      </div>
    </div>
    // document.getElementById('modal-root')
  );
}
export default ModalLvlUp;

